var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsset28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 221.93 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #dc2c2c;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 14.83px;\n      }\n\n      .cls-2 {\n        fill: #dc2c2c;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #10519e;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13",
    "data-name": "Layer 13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.59,150.99l-56.94,104.58c-.29.53-1.07.42-1.21-.16l-11.94-51.58c-.09-.38-.49-.6-.86-.47L.88,221.35c-.56.2-1.08-.4-.79-.93l56.94-104.58c.17-.32.57-.43.88-.26l63.43,34.53c.32.17.43.57.26.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.34,151.08l56.94,104.58c.29.53,1.07.42,1.21-.16l11.94-51.58c.09-.38.49-.6.86-.47l49.78,17.98c.56.2,1.08-.4.79-.93l-56.94-104.58c-.17-.32-.57-.43-.88-.26l-63.43,34.53c-.32.17-.43.57-.26.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.34,62.64l-.28-13.75c-.29-14.15-11.71-25.55-25.87-25.8l-13.59-.24c-6.82-.12-13.33-2.88-18.16-7.71l-7.43-7.42c-10.29-10.28-26.96-10.28-37.25,0l-7.43,7.42c-4.83,4.82-11.33,7.59-18.16,7.71l-13.59.24c-14.16.25-25.58,11.65-25.87,25.8l-.28,13.75c-.14,6.8-2.9,13.28-7.71,18.09l-7.33,7.34c-10.28,10.28-10.28,26.96,0,37.24l7.33,7.34c4.81,4.81,7.57,11.29,7.71,18.09l.28,13.75c.29,14.15,11.71,25.55,25.87,25.8l13.59.24c6.82.12,13.33,2.88,18.16,7.71l7.43,7.42c10.29,10.28,26.96,10.28,37.25,0l7.43-7.42c4.83-4.82,11.33-7.59,18.16-7.71l13.59-.24c14.16-.25,25.58-11.65,25.87-25.8l.28-13.75c.14-6.8,2.9-13.28,7.71-18.09l7.33-7.34c10.28-10.28,10.28-26.96,0-37.24l-7.33-7.34c-4.81-4.81-7.57-11.29-7.71-18.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 110.4,
    cy: 106.69,
    r: 64.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "84.04 108.95 93.18 127.69 136.75 85.68"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset28);
export default __webpack_public_path__ + "static/media/Asset 28.40b91785f214390b2c4e7c92169bec30.svg";
export { ForwardRef as ReactComponent };